/*eslint-disable */
import React, { useState, useEffect } from "react";
import * as yup from "yup";
import {
  Button,
  Modal,
  Form as FormUi,
  Input,
  Checkbox,
  Dropdown,
  Container,
  Segment,
  Icon,
  Table,
} from "semantic-ui-react";
import {
  withFormik,
  Field as Fieldmik,
  FieldArray,
  Form as Formiker,
} from "formik";
import { isEmpty } from "lodash";
import { connect } from "react-redux";
import MandatoryMark from "../common/mandatorymark";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../redux/actions/alertAction";
import { MyInput } from "../dynamicComponent/myInputs";
import { DateData } from "../dynamicComponent/datepick";
import { translate } from "react-i18next";
import moment from "moment";
import { AgGridReact } from "ag-grid-react";
import allAxiosCommonTA from "../axiosComponent/allAxiosCommonTA";
import DatePicker from "react-datepicker";
import { data } from "jquery";
import cogoToast from "cogo-toast";
import ReadAxios from "../axiosComponent/read";
import CreateAxios from "../axiosComponent/create";
import MyVendorComponent from "../dynamicComponent/vendorSearch";
import AddVendorDynamically from "../vendorComponent/addVendorDynamically";
import MyTransporterMaster from "../apiInputs/transporterDropdown";
import FormikBookingVehicleDetailsModal from "./addVehicleDetailsModal";
import MyUnitOfMeasurement from "../apiInputs/myUnitOfMeasurement";

const BookingGenerateOrderModal = ({
  values,
  touched,
  errors,
  isSubmitting,
  handleSubmit,
  setFieldValue,
  t,
  movementType,
  rowSelected,
  ...props
}) => {
  const [modalOpen, setmodalOpen] = useState(false);
  const [orderList, setOrderList] = useState([]);
  const [loopOverList, setLoopOverList] = useState(0);
  const [stateChanged, setStateChanged] = useState(0);
  const [isFormSubmitting, setIsFormSubmitting] = useState(false);

  const [frightlabelName, setFrightlabelName] = useState("Freight Rate");
  const [frightlabelstatus, setfrightlabelstatus] = useState(false);

  const [vehiclDetailsModalOpen, setVehicleDetailsModalOpen] = useState(false)
  const [vehicleDetailsActiveIndex, setVehicleDetailsActiveIndex] = useState(null)
  const [reload, setReload] = useState(false)

  useEffect(() => {
    if (true) {
      getOwnershipType();
      getOwnVendors();

      var tempOrderList = [...props.orders];
      var passOrderList = [];
      var tempOrderListCopy = [...props.orders];

      if (movementType == "primary") {
        for (let i = 0; i < tempOrderList.length; i++) {
          var parts = tempOrderList[i].booking_delivery.requested_pickup_date
            .split("|")[0]
            .split("-");
          var mydate = new Date(parts[2], parts[1] - 1, parts[0]);

          tempOrderList[i].required_on = mydate;
          tempOrderList[i].booking_container_id = null;
          tempOrderList[i].ownership_type_id = null;
          tempOrderList[i].vendor_id = null;
          tempOrderList[i].uom = 'TRIP';
          tempOrderList[i].freight_rate = 1;
          tempOrderList[i].proposed_vehicle_type = tempOrderList?.[i]
            ?.vehicle_type?.vehicle_type_id
            ? tempOrderList[i].vehicle_type.vehicle_type_id
            : null;
          tempOrderList[i].proposed_vehicle_type_placeholder = tempOrderList?.[
            i
          ]?.vehicle_type?.vehicle_type
            ? tempOrderList[i].vehicle_type.vehicle_type
            : "";
          tempOrderList[i].required_vehicle_type = tempOrderList?.[i]
            ?.vehicle_type?.vehicle_type_id
            ? tempOrderList[i].vehicle_type.vehicle_type_id
            : null;
        }
        setOrderList(tempOrderList);
        let temploopOverList = loopOverList + 1;
        setLoopOverList(temploopOverList);
      } else {
        for (let i = 0; i < tempOrderList.length; i++) {
          for (
            let index = 0;
            index < tempOrderList[i].booking_containers.length;
            index++
          ) {
            var element = { ...tempOrderListCopy[i] };

            if (element) {
              const no_container =
                tempOrderList[i].booking_containers[index].no_of_containers;
              element.item_index = index + i;

              var parts = tempOrderList[
                i
              ].booking_delivery.requested_pickup_date
                .split("|")[0]
                .split("-");
              var mydate = new Date(parts[2], parts[1] - 1, parts[0]);
              element.required_on = mydate;

              element.booking_container_id =
                tempOrderList[i].booking_containers[index].booking_container_id;

              element.proposed_vehicle_type = null;
              element.ownership_type_id = null;
              element.vendor_id = null;
              element.uom = 'TRIP';
              element.freight_rate = 1;
              element.proposed_container_size =
                tempOrderList[i].booking_containers[index].container_size;
              element.proposed_container_type =
                tempOrderList[i].booking_containers[index].container_type;
              element.no_of_vehicles = null;

              element.no_of_vehicles = no_container;
              element.pending_vehicles =
                tempOrderList[i].booking_containers[index].pending_containers;
              element.proposed_vehicle_type_placeholder = "";
              element.required_vehicle_type = null;
              passOrderList.push(element);
              element = null;
            }
          }
        }

        let finalOrderCopy = [];
        if (passOrderList) {
          for (let indexj = 0; indexj < passOrderList.length; indexj++) {
            const element = passOrderList[indexj];
            finalOrderCopy.push(element);
          }
          setOrderList(finalOrderCopy);
          let temploopOverList = loopOverList + 1;
          setLoopOverList(temploopOverList);
        }
      }
    }
  }, [props.orders, rowSelected]);

  const [ownershipType, setOwnershiptype] = useState([]);
  const getOwnershipType = () => {
    /* setLoading(true); */
    ReadAxios({
      completeURL: `${process.env.REACT_APP_MASTER_API}/vehicleOwnershipType`,
    })
      .then((res) => {
        //setLoading(false);
        let ownership = res.data.resultSet;
        setOwnershiptype(
          ownership.map((item, index) => {
            return {
              key: index,
              value: item.vehicleOwnershipTypeId,
              text: item.vehicleOwnershipTypeName,
              raw: { ...item },
            };
          })
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const [ownvendor, setOwnVendor] = useState([]);
  const getOwnVendors = () => {
    CreateAxios({
      completeURL: `${process.env.REACT_APP_MASTER_API}/transporterMaster`,
    }).then((result) => {
      let tempown = [];
      let vendorData = result.data.resultSet;
      for (let index = 0; index < vendorData.length; index++) {
        if (vendorData[index].vendorOwnershipType == 1) {
          tempown.push(vendorData[index]);
        }
      }
      tempown = vendorData.map((item, index) => {
        return {
          key: index + 1,
          text: item.transporterName,
          value: item.transporterMasterId,
          raw: { ...item },
        };
      });
      setOwnVendor(tempown);
    });
  };

  let handleOpen = () => setmodalOpen(true);

  let handleClose = () => {
    setmodalOpen(false);
  };

  const columnDefs = [
    {
      headerName: "Booking No",
      field: "booking_number",
    },
    {
      headerName: "Booking Date & Time",
      field: "booking_date",
      width: "4",
    },
    {
      headerName: "Booking Branch",
      field: "booking_branch",
    },
    {
      headerName: "Origin",
      field: "source",
    },
    {
      headerName: "Destination",
      field: "destination",
    },
    {
      headerName:
        movementType == "primary"
          ? "Total Vehicles"
          : movementType == "import"
            ? "Total Containers"
            : "Total Containers",
      field: "no_of_vehicles",
    },
    {
      headerName:
        movementType == "primary"
          ? "No of Vehicles"
          : movementType == "import"
            ? "No of Containers"
            : "No of Containers",
      field: "pending_vehicles",
    },
    {
      headerName:
        movementType == "primary"
          ? "Pending Vehicles"
          : movementType == "import"
            ? "Pending Containers"
            : "Pending Containers",
      field: "pending_vehicles",
    },
    {
      headerName: "Gross Weight",
      field: "gross_weight",
    },
    {
      headerName: " ",
      field: "",
    },
    {
      headerName:
        movementType == "primary"
          ? "Consignor Name"
          : movementType == "import"
            ? "Port Terminal Name"
            : "Stuffing Location Name",
      field: "consignor_name",
    },
    {
      headerName: "Vehicle Required On",
      field: "required_on",
    },
    {
      headerName: "Ownership Type",
      field: "ownership_type_id",
    },
    {
      headerName: "Vendor",
      field: "vendor_id",
    },
    {
      headerName: "Uom",
      field: "uom",
    },

    {
      headerName:
        localStorage.getItem("customerNumber") == 1360
          ? frightlabelstatus
            ? frightlabelName
            : ""
          : "Freight Rate",
      field: "freight_rate",
    },
    {
      headerName: "Proposed Vehicle Type",
      field: "proposed_vehicle_type",
    },
    {
      headerName: "Container Size",
      field: "proposed_container_size",
      sortable: true,
      filter: true,
      hide: movementType != "primary" ? false : true,
    },
    {
      headerName: "Container Type",
      field: "proposed_container_type",
      sortable: true,
      filter: true,
      hide: movementType != "primary" ? false : true,
    },
  ];

  const dropdown = (
    props,
    index,
    movementType,
    requiredVehicleType,
    requiredContainerType,
    placeholder,
    valueObj
  ) => {
    return (
      <>
        <Dropdown
          selection
          style={{ width: "100%" }}
          options={requiredVehicleType}
          onChange={(e, data) => handleChangeSelect(e, data, index)}
          placeholder={
            placeholder && placeholder != null && placeholder != undefined
              ? placeholder
              : ""
          }
          value={valueObj}
        />
      </>
    );
  };
  const handleChangeSelect = (name, data, index) => {
    let tempObj = orderList[index];
    tempObj.required_vehicle_type = data.value;
    let tempOrderList = orderList;
    tempOrderList[index] = tempObj;
    setOrderList(tempOrderList);
    fetchFreightRate(index)
    setReload(!reload)
  };

  const generateBookingRequest = () => {
    let bookingInput = [];
    let error = 0;
    for (let i = 0; i < orderList.length; i++) {
      let temp = {};
      if (
        orderList[i].booking_id == null ||
        orderList[i].booking_id == undefined ||
        //orderList[i].no_of_vehicles_ordered == null ||
        //orderList[i].no_of_vehicles_ordered == undefined ||
        ((orderList[i].required_vehicle_type == null ||
        orderList[i].required_vehicle_type == undefined) &&
        (orderList[i].vehicle_details?.vehicle_type == null ||
          orderList[i].vehicle_details?.vehicle_type == undefined)) ||
        orderList[i].required_on == null ||
        orderList[i].required_on == undefined ||
        (localStorage.getItem("customerNumber") == 1360 &&
          (orderList[i].vendor_id == undefined ||
            orderList[i].vendor_id == null))
      )
        error++;
      else error = error;

      temp.booking_container_id = orderList[i].booking_container_id;
      temp.booking_id = orderList[i].booking_id;
      temp.no_of_vehicles_or_containers = orderList[i]?.no_of_vehicles_ordered
        ? orderList[i].no_of_vehicles_ordered
        : 1;
      temp.proposed_vehicle_type = orderList[i].required_vehicle_type || orderList[i]?.vehicle_details?.vehicle_type;
      temp.required_on = moment(orderList[i].required_on).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      temp.ownership_type_id = orderList[i].ownership_type_id;
      temp.vendor_id = orderList[i].vendor_id;
      temp.freight_rate = orderList[i].freight_rate;
      temp.vehicle_details = orderList[i].vehicle_details;
      bookingInput.push(temp);
    }
    if (error == 0) {
      setIsFormSubmitting(true);
      allAxiosCommonTA({
        url: "/bookings/generate-order",
        method: "post",
        Items: { bookingInput: bookingInput },
      })
        .then((response) => {
          setIsFormSubmitting(false);
          for (let index = 0; index < response.data.message.length; index++) {
            const element = response.data.message[index].message;
            cogoToast.info(element, { hideAfter: 7.5 });
          }
          setTimeout(() => {
            handleClose();
            window.location.reload();
          }, 100);
        })
        .catch((err) => {
          setIsFormSubmitting(false);
          if (err.data && (err.data.error || err.data.message)) {
            if (err.data.message) {
              cogoToast.success(err.data.message);
              setTimeout(() => {
                handleClose();
              }, 100);
            } else {
              cogoToast.error(err.data.error);
            }
          } else {
            cogoToast.error("Error while generating order");
          }
        });
    } else {
      cogoToast.error("Please provide all the required details.");
    }
  };

  const changeVehicleRequest = (e, item, index) => {
    let tempOrderList = orderList;
    let tempList = orderList[index];
    let compare = item.no_of_vehicles;
    tempList.errorVehicle = false;
    if (compare < parseInt(e.target.value || parseInt(e.target.value) < 0)) {
      tempList.errorVehicle = true;
      document.getElementById("error-code-" + index).style.display = "block";
    } else {
      document.getElementById("error-code-" + index).style.display = "none";
    }
    tempList.no_of_vehicles_ordered = parseInt(e.target.value);
    tempOrderList[index] = tempList;
    setOrderList(tempOrderList);
  };

  const changeOwnershipType = (e, item, index) => {
    let tempOrderList = orderList;
    let tempList = orderList[index];
    tempList.ownership_type_id = item.value;
    // tempList.vendor_id = null;
    tempOrderList[index] = tempList;
    setStateChanged(!stateChanged);
    setOrderList(tempOrderList);
    if (localStorage.getItem("customerNumber") == 1360) {
      if (item.value == 1) {
        setFrightlabelName("Freight Rate");
        setfrightlabelstatus(false);
      } else if (item.value == 2) {
        setFrightlabelName("Vendor Freight Rate");
        setfrightlabelstatus(true);
      } else if (item.value == 3) {
        setFrightlabelName("Freight Rate");
        setfrightlabelstatus(true);
      }
    }
  };

  const changeVendor = (e, item, index) => {
    let tempOrderList = orderList;
    let tempList = orderList[index];
    tempList.vendor_id = item.value;
    tempOrderList[index] = tempList;
    setOrderList(tempOrderList);
    fetchFreightRate(index)
  };

  const setVendorRate = (item, index, event) => {
    let tempOrderList = orderList;
    let tempList = orderList[index];
    tempList.freight_rate = +event.target.value;
    tempOrderList[index] = tempList;
    setOrderList(tempOrderList);
  };

  const setRequiredDate = (item, date, index) => {
    let temp = orderList;

    let newDate = new Date(date.getTime());

    let passTemp = temp.map((item, idx) => {
      if (idx == index) {
        const newItem = Object.keys(item).reduce((accumulator, key) => {
          if (key !== "required_on") {
            accumulator[key] = item[key];
          }
          return accumulator;
        }, {});
        let itemtemp = newItem;
        itemtemp.required_on = new Date(newDate);

        return itemtemp;
      } else {
        return item;
      }
    });

    setOrderList(passTemp);

    setStateChanged(!stateChanged);
    let temploopOverList = loopOverList + 1;
    setLoopOverList(temploopOverList);
  };

  const closeVehicleDetailsModal = ()=> {
    setVehicleDetailsActiveIndex(null)
    setVehicleDetailsModalOpen(false)
  }

  const openVehicleDetailsModal = (index) => {
    if(orderList && orderList.length && !orderList[index].vendor_id){
      cogoToast.error("Please allot vendor to add vehicle details.")
      return ;
    }
    setVehicleDetailsActiveIndex(index)
    setVehicleDetailsModalOpen(true)
  }

  const submitVehicleDetails = (vehicleDetails) => {
    if(orderList && orderList.length){
      let orderDetails = orderList
      orderDetails[vehicleDetailsActiveIndex].vehicle_details = vehicleDetails
      orderDetails[vehicleDetailsActiveIndex].ownership_type_id = vehicleDetails.ownership_type
      orderDetails[vehicleDetailsActiveIndex].required_vehicle_type = vehicleDetails.vehicle_type
      setOrderList(orderDetails)
      fetchFreightRate(vehicleDetailsActiveIndex)
      setVehicleDetailsActiveIndex(null)
      setVehicleDetailsModalOpen(false)
    }
  }

  const changeUom = (data, index) => {
    let order_details = orderList
    order_details[index].uom = data.value
    setOrderList(order_details)
    fetchFreightRate(index)
    setReload(!reload)
  }

  const fetchFreightRate = (index) => {
    try{
        let orderObj = orderList[index]
        let paylod = {
        booking_id : orderObj.booking_id,
        proposed_vehicle_type : orderObj.required_vehicle_type,
        vendor_id : orderObj.vendor_id,
        uom : orderObj.uom
      }
      allAxiosCommonTA({
        url: "/bookings/fetch/freightRate",
        method: "post",
        Items: paylod,
      }).then((response)=>{
        if(res.data?.status == 1){
          let freight_amount = res?.data?.data?.final_freight_rate || 1
          let order_details = orderList
          order_details[index].freight_rate = freight_amount
          setOrderList(order_details)
          setReload(!reload)
        }
      }).catch((err)=>{
        console.log(err);
      })
    }catch(err){
      console.log(err);
    }
  }

  return (
    <div>
      <Modal
        open={modalOpen}
        onClose={handleClose}
        size="fullscreen"
        style={{
          padding: "50px 0 50px 0",
        }}
        trigger={
          <Button
            type="button"
            onClick={handleOpen}
            size="mini"
            color="green"
            className="m-2 w3-hover-green"
            circular
          >
            {"Generate Order"}
          </Button>
        }
      >
        <Modal.Header className="p-bold-100">
          <div className="d-flex justify-content-between">
            <label className="font-weight-normal">{"Generate Order"}</label>
            <div className="form-inline">
              <i onClick={handleClose} className="fas fa-times"></i>
            </div>
          </div>
        </Modal.Header>
        <Modal.Content scrolling>
          <Table className="generate-order-table">
            <Table.Header>
              <Table.Row>
                {columnDefs.map((item, index) => (
                  <Table.HeaderCell
                    key={"brheader" + `${index}`}
                    className={
                      (item.headerName
                        .trim()
                        .localeCompare("Container Type".trim()) == 0 ||
                        item.headerName
                          .trim()
                          .localeCompare("Container Size".trim()) == 0) &&
                        movementType.localeCompare("primary") == 0
                        ? "hide-section"
                        : "show"
                    }
                  >
                    {item.headerName}
                    {localStorage.getItem("customerNumber") == 1360 &&
                      item.headerName == "Vendor" ? (
                      <label className="required-form-element"></label>
                    ) : null}
                  </Table.HeaderCell>
                ))}
                <Table.HeaderCell colSpan={2}></Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {orderList.map((item, index) => (
                <Table.Row key={"brvalues" + `${index}`}>
                  <Table.Cell>{item.booking_number}</Table.Cell>
                  <Table.Cell>{item.booking_date}</Table.Cell>
                  <Table.Cell>{item.booking_branch}</Table.Cell>
                  <Table.Cell>{item.source}</Table.Cell>
                  <Table.Cell>{item.destination}</Table.Cell>
                  <Table.Cell>{item.no_of_vehicles}</Table.Cell>
                  <Table.Cell>
                    <Input
                      type="number"
                      min="0"
                      className="remove-incrementer"
                      style={{ width: '80px' }}
                      defaultValue={1}
                      max={item.pending_vehicles}
                      onChange={(e) => changeVehicleRequest(e, item, index)}
                    />
                    <p className="display-none" id={`error-code-${index}`}>
                      Please enter valid no of vehicle
                    </p>
                  </Table.Cell>
                  <Table.Cell>{item.pending_vehicles}</Table.Cell>
                  <Table.Cell>{item.gross_weight}</Table.Cell>
                  <Table.Cell>{item.billing_party_name}</Table.Cell>
                  <Table.Cell>
                    {item?.booking_delivery?.consignor_name}
                  </Table.Cell>
                  <Table.Cell>
                    <DatePicker
                      id={`required-on-${index}`}
                      selected={item.required_on}
                      onChange={(date) => setRequiredDate(item, date, index)}
                      dateFormat="dd-MM-yyyy"
                      //showTimeSelect
                      /* timeFormat="HH:mm" */
                      //timeIntervals={15}
                      /* timeCaption="time" */
                      /* dateFormat="mm/DD/yyyy" */
                      customInput={
                        <Input
                          defaultValue={item.required_on}
                          className="dateWidth"
                          icon="calendar alternate outline"
                          iconPosition="left"
                        />
                      }
                    />
                  </Table.Cell>
                  <Table.Cell>
                    <Dropdown
                      id={`ownership-type-${index}`}
                      clearable
                      style={{ width: "100%", fontWeight: "normal" }}
                      search
                      selection
                      placeholder={"Ownership Type"}
                      onChange={(name, data) => {
                        changeOwnershipType(item, data, index);
                      }}
                      options={ownershipType}
                      value = {item.ownership_type_id}
                    />
                  </Table.Cell>
                  <Table.Cell className="display-flex-center-justify-center">
                    {item?.ownership_type_id == 1 ? (
                      <Dropdown
                        id={`select-vendor-${index}`}
                        clearable
                        style={{ width: "100%", fontWeight: "normal" }}
                        search
                        selection
                        placeholder={"Select Vendor"}
                        onChange={(name, data) => {
                          changeVendor(item, data, index);
                        }}
                        options={ownvendor}
                      />
                    ) : (
                      <>
                        <Fieldmik
                          onChange={(name, data) => {
                            changeVendor(item, data, index);
                          }}
                          name="transporter_name"
                          component={MyTransporterMaster}
                          id={`vendor-select-${index}`}
                          placeholder={"Select Vendor"}
                          IdValue = {true}
                          vendorOwnershipFilter={true}
                          onlyNameText={true}
                        />
                      </>
                    )}
                    <AddVendorDynamically />
                  </Table.Cell>

                  <Table.Cell>  
                        <Fieldmik
                          onChange={(name, data) => {
                            changeUom(data, index);
                          }}
                          name="uom"
                          component={MyUnitOfMeasurement}
                          value = {orderList[index]?.uom}
                        />
                  </Table.Cell>

                  <Table.Cell>
                    {localStorage.getItem("customerNumber") != 1360 ? (
                      <>
                        <Input
                          type="number"
                          min="1"
                          className=""
                          defaultValue={1}
                          //min={1}
                          style={{ width: '80px' }}
                          onChange={(name, data) => {
                            setVendorRate(item, index, name);
                          }}
                        />
                      </>
                    ) : null}
                    {localStorage.getItem("customerNumber") == 1360 &&
                      frightlabelstatus == true ? (
                      <>
                        <Input
                          type="number"
                          min="1"
                          className=""
                          defaultValue={1}
                          style={{ width: '80px' }}
                          onChange={(name, data) => {
                            setVendorRate(item, index, name);
                          }}
                        />
                      </>
                    ) : null}
                  </Table.Cell>

                  <Table.Cell>
                    {dropdown(
                      item,
                      index,
                      movementType,
                      props.requiredVehicleType,
                      props.requiredContainerType,
                      item?.proposed_vehicle_type_placeholder
                        ? item.proposed_vehicle_type_placeholder
                        : "",
                      item?.required_vehicle_type
                    )}
                  </Table.Cell>
                  {movementType != "primary" && (
                    <Table.Cell>{item.proposed_container_size}</Table.Cell>
                  )}
                  {movementType != "primary" && (
                    <Table.Cell>{item.proposed_container_type}</Table.Cell>
                  )}
                  <Table.Cell colSpan={2}>
                      <button
                        className="w3-button w3-blue w3-hover-blue w3-round w3-small"
                        onClick={()=> openVehicleDetailsModal(index)}
                      >
                        Add Vehicle Details
                      </button>
                      <FormikBookingVehicleDetailsModal modalOpen={vehiclDetailsModalOpen} handleClose={closeVehicleDetailsModal} order={orderList.length && orderList[0]} submitVehicleDetails={submitVehicleDetails}/>
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
          <div
            className="display-flex-center-justify-center"
            style={{
              padding: "50px 0 100px 0",
            }}
          >
            <button
              className="submit-generate-order w3-button w3-blue w3-hover-blue w3-round w3-small"
              onClick={generateBookingRequest}
              disabled={isFormSubmitting}
            >
              {isFormSubmitting ? <Icon name="spinner" /> : <span>Submit</span>}
            </button>
          </div>
        </Modal.Content>
        {/* </Formiker> */}
      </Modal>
    </div>
  );
};
// TODO: validation
const FormikGenerateOrder = withFormik({
  validationSchema: yup.object({}),
  mapPropsToValues: (props) => {
    return {};
  },
  handleSubmit(values, { setSubmitting, props }) { },
})(BookingGenerateOrderModal);

export default connect(null, { successAlertDispatcher, errorAlertDispatcher })(
  translate("broadcast")(FormikGenerateOrder)
);
